import { DoseSpotPharmacy, Pharmacy } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { SurveysContext, SurveysContextProps } from '@/contexts/indications'

interface UsePharmacyProps {
  selectedPharmacy: SurveysContextProps['selectedPharmacy']
  updateSelectedPharmacy: (selectedPharmacy: Pharmacy | DoseSpotPharmacy) => void
  clearSelectedPharmacy: () => void
}

export const usePharmacy = (): UsePharmacyProps => {
  const { selectedPharmacy, setSelectedPharmacy } = useContext(SurveysContext)

  const updateSelectedPharmacy = (pharmacy: Pharmacy | DoseSpotPharmacy) => {
    setSelectedPharmacy((prev) => (prev?.id === pharmacy.id ? null : pharmacy))
  }

  const clearSelectedPharmacy = () => {
    setSelectedPharmacy(null)
  }

  return {
    selectedPharmacy,
    updateSelectedPharmacy,
    clearSelectedPharmacy
  }
}
